module.exports = __webpack_public_path__ + "files/05226489d0336970417b4424d9712a91.png";